// Shared colour scale for the AI message-cap indicators (app sidebar row and
// the AI workspace trial card): green while usage is comfortable, yellow once
// it crosses 60 %, red from 90 % — i.e. at or next to the maximum.
export function aiUsageBarClass(percent: number): string {
    if (percent >= 90) {
        return "bg-[#FF4D4D]";
    }

    if (percent >= 60) {
        return "bg-[#F9CC44]";
    }

    return "bg-[#04C951]";
}
